/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  getGroupMembers(conversationID) {
    return axios.get(`${this.url}/${conversationID}/group_members`);
  }

  openGroupMemberConversation(conversationID, memberId) {
    return axios.post(
      `${this.url}/${conversationID}/group_members/direct_conversation`,
      {
        member_id: memberId,
      }
    );
  }

  addGroupMember(conversationID, phoneNumber) {
    return axios.post(`${this.url}/${conversationID}/group_members`, {
      phone_number: phoneNumber,
    });
  }

  removeGroupMember(conversationID, memberId) {
    return axios.post(`${this.url}/${conversationID}/group_members/remove`, {
      member_id: memberId,
    });
  }

  getGroupInviteLink(conversationID) {
    return axios.get(`${this.url}/${conversationID}/group_members/invite_link`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }
}

export default new ConversationApi();
